import { atom } from "jotai";

import type { DocsListItem } from "./document-list.types";

// Template documents atom - templates being previewed are added here temporarily.
// These are remote documents from the moment-templates workspace that should be
// treated as read-only (no local, no collab).
export const $templateDocuments = atom({} as Record<string, DocsListItem>);
$templateDocuments.debugLabel = "templateDocuments";

/**
 * Writable atom to add a template document to the template list.
 * Use this when previewing a template to make it appear in the documents list
 * so the standard document loader can load it.
 */
export const $addTemplateDocument = atom(null, (get, set, document: DocsListItem) => {
	const current = get($templateDocuments);
	set($templateDocuments, { ...current, [document.id]: document });
});
$addTemplateDocument.debugLabel = "addTemplateDocument";

/**
 * Writable atom to remove a template document from the template list.
 * Use this when closing a template preview.
 */
export const $removeTemplateDocument = atom(null, (get, set, documentId: string) => {
	const current = get($templateDocuments);
	const { [documentId]: _, ...rest } = current;
	set($templateDocuments, rest);
});
$removeTemplateDocument.debugLabel = "removeTemplateDocument";
